/**
 * CaseManageSlice Notes Reducers
 * 
 * Reducers for managing notes on cases.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { NoteView } from '../../types/caseManageTypes';
import { CaseManageSliceState } from '../state';

// =============================================================================
// NOTES REDUCERS
// =============================================================================

/**
 * Add a new note to the case
 */
export const addNote: CaseReducer<CaseManageSliceState, PayloadAction<Omit<NoteView, 'noteId'>>> = (
  state,
  action
) => {
  if (state.currentCase) {
    const newNote: NoteView = {
      ...action.payload,
      noteId: `temp_${Date.now()}`, // Temporary ID until saved
    };
    state.currentCase.notes.push(newNote);
    state.isEdited = true;
    if (!state.editedFields.includes('notes')) {
      state.editedFields.push('notes');
    }
  }
};

/**
 * Update an existing note
 */
export const updateNote: CaseReducer<
  CaseManageSliceState,
  PayloadAction<{ noteId: string; updates: Partial<NoteView> }>
> = (state, action) => {
  if (state.currentCase) {
    const noteIndex = state.currentCase.notes.findIndex(
      (note) => note.noteId === action.payload.noteId
    );
    if (noteIndex !== -1) {
      state.currentCase.notes[noteIndex] = {
        ...state.currentCase.notes[noteIndex],
        ...action.payload.updates,
      };
      state.isEdited = true;
      if (!state.editedFields.includes('notes')) {
        state.editedFields.push('notes');
      }
    }
  }
};

/**
 * Remove a note from the case
 */
export const removeNote: CaseReducer<CaseManageSliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (state.currentCase) {
    state.currentCase.notes = state.currentCase.notes.filter(
      (note) => note.noteId !== action.payload
    );
    state.isEdited = true;
    if (!state.editedFields.includes('notes')) {
      state.editedFields.push('notes');
    }
  }
};
